import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import RectangularButton from '../../../components/buttons/RectangularButton';
import { formatMoneyInteger } from '../../../utils/priceFormatter';
import { SubTitle } from '../../../components/typography/Headers';
import BidInput from '../../../components/inputs/BidInput';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

interface Props {
  currentItemPrice?: number | null;
  minBidPrice: number;
  maxBidPrice?: number;
  onPlaceBid: (price: number) => void;
}

const PlaceBidPopup = ({ currentItemPrice, maxBidPrice, onPlaceBid, minBidPrice }: Props) => {
  const { t } = useTranslation('onsite');
  const [bid, setBid] = useState<number>();

  const inputPlaceholder =
    currentItemPrice != null
      ? t('bids.bid-input-placeholder', { bidAmount: formatMoneyInteger(currentItemPrice) })
      : '';

  const onPlaceBidClick = () => {
    if (bid) {
      onPlaceBid(bid);
    }
  };

  return (
    <Container>
      <SubTitle>{t('bids.enter-bid')}</SubTitle>
      <BidInput value={bid} onChange={setBid} placeholder={inputPlaceholder} maxValue={maxBidPrice} />
      <RectangularButton
        label={t('bids.confirm-bid')}
        onClick={onPlaceBidClick}
        disabled={!bid || bid < minBidPrice}></RectangularButton>
    </Container>
  );
};

export default PlaceBidPopup;
